<template>
  <div class="page-header">
    <div :class="['page-header-wide', layout]">
      <div class="breadcrumb">
        <a-breadcrumb>
          <a-breadcrumb-item :key="item.path" v-for="(item, index) in breadcrumb">
            <span>{{item.name}}</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
      </div>
      <div class="detail">
        <div v-if="avatar" class="avatar">
          <a-avatar :src="avatar" />
        </div>
        <div class="main">
          <div class="row">
            <img v-if="logo" :src="logo" class="logo" />
            <h1 v-if="title" class="title">{{title}}</h1>
             <a-button style="margin-left:20px" v-if="hasRefreshBtn" @click="$emit('refreshPage')" type="primary" ghost>刷新</a-button>
        
            <div class="action">
              <slot name="action">
                <div class="m_action_cust" v-if="titlesInUpdateClass.includes(title)">
                  <span class="u_prompt">提示:</span>
                  <span class="u_cust_green">信息被添加</span>
                  <span class="u_cust_blue">信息被删除</span>
                  <span class="u_cust_yellow">信息被修改</span>
                </div>
              </slot>
            </div>
          </div>
          <!-- <div class="row">
            <div v-if="this.$slots.content" class="content"><slot name="content"></slot></div>
            <div v-if="this.$slots.extra" class="extra"><slot name="extra"></slot></div>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMenuData } from "@/libs/global";
export default {
    name: "pageHeader",
    props: {
        hasRefreshBtn:{
            type: Boolean,
            required: false
        },
        logo: {
            type: String,
            required: false
        },
        avatar: {
            type: String,
            required: false
        },
        custQuaUpdate: {
            type: Boolean
        }
    },
    data() {
        return {
            // 以下页面的右上方将出现更新对比提示文字
            titlesInUpdateClass: [
                "审核客户更新",
                "审核建采更新",
                "查看店铺更新信息",
                "审核店铺认证更新",
                "撤回店铺更新信息"
            ],
            title: "",
            breadcrumb: []
        };
    },
    mounted() {
        this.getBreadcrumb();
    },
    computed: {
        layout() {
            return this.$store.state.setting.layout;
        }
    },
    methods: {
        getBreadcrumb() {
            this.title = this.$route.name;
            getMenuData(this.$route.path)
                .then(menuData => {
                    this.breadcrumb = menuData;
                })
                .catch(e => {
                    console.log(e);
                    this.$message.error(e.message);
                });
        }
    }
};
</script>

<style lang="less" scoped>
.page-header {
    margin: -25px -25px 24px;
    background: #fff;
    padding: 16px 32px 0;
    border-bottom: 1px solid #e8e8e8;
    .page-header-wide {
        &.head {
            margin: auto;
            max-width: 1400px;
        }
        &.side {
        }
        .breadcrumb {
            margin-bottom: 8px;
        }
        .detail {
            display: flex;
            .row {
                overflow: hidden;
                width: 100%;
            }
            .avatar {
                flex: 0 1 72px;
                margin: 0 24px 8px 0;
                & > span {
                    border-radius: 72px;
                    display: block;
                    width: 72px;
                    height: 72px;
                }
            }
            .main {
                width: 100%;
                flex: 0 1 auto;
                .title {
                    float: left;
                    font-size: 18px;
                    font-weight: 500;
                    color: rgba(0, 0, 0, 0.85);
                    margin-bottom: 16px;
                }
                .logo {
                    width: 28px;
                    height: 28px;
                    border-radius: 4px;
                    margin-right: 16px;
                }
                .content {
                    margin-bottom: 16px;
                    flex: auto;
                }
                .extra {
                    flex: 0 1 auto;
                    margin-left: 88px;
                    min-width: 242px;
                    text-align: right;
                }
                .action {
                    float: right;
                    margin-left: 56px;
                    min-width: 266px;
                    text-align: right;

                    .m_action_cust {
                        color: #333;
                        text-align: center;
                        .u_prompt {
                            font-weight: 700;
                        }
                        .u_cust_green {
                            background-color: #d1fede;
                            width: 100px;
                            height: 30px;
                            display: inline-block;
                            line-height: 30px;
                            margin-left: 10px;
                        }
                        .u_cust_blue {
                            background-color: #d0defe;
                            width: 100px;
                            height: 30px;
                            display: inline-block;
                            line-height: 30px;
                            margin-left: 10px;
                        }
                        .u_cust_yellow {
                            background-color: #ffffcc;
                            width: 100px;
                            height: 30px;
                            display: inline-block;
                            line-height: 30px;
                            margin-left: 10px;
                        }
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/PageHeader.vue